<template>
    <div class='flexStart search-main'>
        <div class='flexStart search-main-left'>
            <template v-for="(cfg,index) in formConfig">
                <div v-show="showMore(index)" class="search-item spaceLeft" :key="index" :style="'width:'+itemWidth">
                        <div class="search-item-label">{{cfg.label}}：</div>
                        <div class="search-item-main">
                            <el-input
                            size="mini"
                            class="search-input"
                                @keyup.enter="serachHandle(cfg)"
                                v-if="cfg.type == 'input'"
                                :placeholder="cfg.placeholder||''"
                                v-model="sourceSelf[cfg.prop]">
                            </el-input>

                            <el-date-picker
                            size="mini"
                            class="search-input"
                                style="width:100%"
                                v-if="cfg.type == 'dateRange'"
                                v-model="sourceSelf[cfg.prop]"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                range-separator="-"
                                start-placeholder="start date"
                                end-placeholder="end date">
                            </el-date-picker>

                            <el-date-picker
                            size="mini"
                            class="search-input"
                                style="width:100%"
                                v-if="cfg.type == 'date'"
                                v-model="sourceSelf[cfg.prop]"
                                type="date"
                                :value-format="cfg.format || 'yyyy-MM-dd'"
                                >
                            </el-date-picker>
                            
                            <el-date-picker
                            size="mini"
                            class="search-input"
                                style="width:100%"
                                v-if="cfg.type == 'month'"
                                v-model="sourceSelf[cfg.prop]"
                                type="month"
                                :value-format="cfg.format || 'yyyyMM'"
                                >
                            </el-date-picker>
                            

                            <el-select
                            size="mini"
                                filterable
                                class="search-input"
                                v-if="cfg.type == 'select'"
                                v-model="sourceSelf[cfg.prop]"
                                clearable
                                :placeholder="cfg.placeholder||''">
                                <el-option
                                v-for="op in cfg.options"
                                :key="cfg.optionItem?op:op[cfg.valueProp||'value']"
                                :label="cfg.optionItem?op:op[cfg.labelProp||'text']"
                                :value="cfg.optionItem?op:op[cfg.valueProp||'value']">
                                </el-option>
                            </el-select>

                            <!-- <searchSelect
                            v-if="cfg.type == 'searchSelect'"
                            :searchProp="cfg.searchProp||cfg.prop"
                            :valueProp="cfg.valueProp"
                            v-model="sourceSelf[cfg.prop]"
                            :cols="cfg.cols"
                            :action="cfg.action"
                            :params="cfg.params"/> -->
                        </div>
                </div>
            </template>
        </div>
        <div class="search-item spaceLeft">
            <el-button type="primary" icon="el-icon-search" @click="serachHandle" size="mini">Query</el-button>
            <el-button icon="el-icon-refresh" @click="searchReset" size="mini">Reset</el-button>
            <el-button v-if="more&&formConfig.length>3" :icon="isOpen?'el-icon-arrow-up':'el-icon-arrow-down'" @click="openSearch" size="mini"></el-button>
        </div>
    </div>
</template>

<script>
import {deepClone} from "@/utils/index.js"
export default {
    props: {
        source: {
            type: [Object],
            required: false,
            default: function () {
                return {};
            },
        },
        formConfig: {
            type: [Array],
            required: true,
            default: function () {
                return [];
            },
        },
        more:{
            type: [Boolean],
            required: false,
            default: function () {
                return true;
            },
        },
        more:{
            type: [Boolean],
            required: false,
            default: function () {
                return true;
            },
        },
        itemWidth:{
            type: [String],
            required: false,
            default: function () {
                return '280px';
            },
        }
    },
    name:"searchForm",
    components: {},
    data() {
        return {
            sourceSelf: deepClone(this.source),
            rowOption:[],
            colOption:[],
            nameOption:[],
            isOpen:false
        };
    },
    computed: {},
    methods: {
        serachHandle(cfg){
            this.$emit("serachHandle",this.sourceSelf,cfg);
        },
        handleReset(){
            for (let i in this.sourceSelf) {
                let val = this.sourceSelf[i];
                if (Array.isArray(val)) {
                    this.sourceSelf[i] = [];
                } else if (typeof val === "object") {
                    this.sourceSelf[i] = {};
                } else {
                    this.sourceSelf[i] = undefined;
                }
            }
        },
        searchReset(btn){
            this.handleReset()
            this.serachHandle(btn);
        },
        nameChange(){
            this.rowOption = [];
            this.sourceSelf.positionRow = "";
            this.sourceSelf.positionColumn = "";
            this.getRows();
        },
        rowChange(){
            this.colOption = [];
            this.sourceSelf.positionColumn = "";
            this.getCols();
        },
        getName(){
            storeName().then(res => {
                this.nameOption = res.data;
            })
        },
        getRows(){
            if(this.sourceSelf.storeName){
                positionRow(this.sourceSelf.storeName).then(res => {
                    this.rowOption = res.data;
                })
            }
        },
        getCols(){
            if(this.sourceSelf.storeName && this.sourceSelf.positionRow){
                positionColumn(this.sourceSelf.storeName,this.sourceSelf.positionRow).then(res => {
                    this.colOption = res.data;
                })
            }
        },
        openSearch(){
            this.isOpen = !this.isOpen;
        },
        showMore(index){
            if(!this.more){
                return true;
            }
            return index <= 2 || this.isOpen;
        }
    },
    created() {
        if(this.formConfig.find(i => i.type == "kuwei")){
            this.getName();
        }

    },
    watch: {
        source: {
            handler(newVal, oldVal) {
                this.sourceSelf = deepClone(this.source);
            },
            deep: true
        }
    }
}
</script>
<style scoped lang="scss">
.search-main{
    margin-bottom: 8px;
    .search-main-left{
        flex:1;
        flex-wrap: wrap;
    }
}
.search-item{
    font-size: 12px;
    margin-right: 30px;
    margin-bottom: 20px;
    .search-item-label{
        font-weight: normal;
    }
    ::v-deep .el-input__inner{
        border:1px solid #DFDFF0;
    }
    .search-input{
        width: 100%;
        flex: 1;
    }
    .search-item-label{
        display: inline-block;
    }
    .search-item-main{
        width: 100%;
        flex: 1;
    }
    ::v-deep .el-date-editor .el-range__icon{
        display: none;
    }

}
</style>
